const additionalItems: string[] = ['Data Feeds', 'Access for Additional Users'];

export default additionalItems;
